<template>
  <BasePageContainer
    v-if="goal"
    ref="container"
    class="page activity_result activity_result_edit pt-4 pb-8"
    :style="{'padding-top': '24px', 'padding-bottom': containerPaddingBottom}">
    <div class="page__head edit-head fixed-top p-3">
      <h1 class="edit-head__heading">
        <img
          src="@/assets/images/pen-memoicon.png"
          class="img-fluid edit-head__icon mr-2">
        <span class="edit-head__activity mr-2">
          {{ goal.name }}
        </span>
      </h1>
    </div>
    <div
      v-if="activity"
      class="page__form general-form pt-6">
      <validation-observer
        ref="observer"
        v-slot="observer">
        <form>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">活動名</label>
            <validation-provider
              v-slot="{ errors }"
              rules="required|max:40"
              name="活動名">
              <input
                v-model="activity.name"
                type="text"
                class="form-control">
              <p class="text-primary">
                {{ errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">活動日時</label>
            <div class="d-flex align-items-center justify-content-between">
              <validation-provider
                v-slot="{ errors }"
                class="pl-0 col-md"
                name="日付"
                rules="required|valid_date|activity_after_date:@ノート開始日|activity_before_date:@ノート終了日">
                <b-form-datepicker
                  v-model="workAtDate"
                  placeholder="日付を選択してください"
                  hide-header
                  :min="goal.startDate"
                  :max="goal.endDate"
                  locale="ja"
                  :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    weekday: 'short'
                  }"
                  class="align-items-center">
                  <template v-slot:button-content>
                    <div
                      class="material-icons mr-2 d-flex align-items-center">
                      event_available
                    </div>
                  </template>
                </b-form-datepicker>
              </validation-provider>
              <validation-provider
                v-slot="{ errors }"
                class="pr-0 col"
                style="min-width: 145px;"
                rules="required|valid_time"
                name="時間">
                <b-form-timepicker
                  v-model="workAtTime"
                  hide-header
                  no-close-button
                  placeholder="時間を選択してください" 
                  class="align-items-center" />
              </validation-provider>
              <!-- validationするための要素 -->
              <validation-provider name="ノート開始日">
                <input
                  :value="goal.startDate"
                  class="d-none">
              </validation-provider>
              <validation-provider name="ノート終了日">
                <input
                  :value="goal.endDate"
                  class="d-none">
              </validation-provider>
            </div>
            <div>{{ activity.date }}</div>
            <p class="text-primary">
              {{ dateErrorMessage(observer['errors']['日付']) }}
            </p>
            <p class="text-primary">
              {{ dateErrorMessage(observer['errors']['時間']) }}
            </p>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <div class="row">
              <div class="col-6">
                <label
                  class="col-form-label">達成カウント</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="達成カウント"
                  rules="required|hankaku_number">
                  <input
                    v-model="activity.resultCount"
                    type="number"
                    min="0"
                    class="form-control">
                  <p class="text-primary">
                    {{ errors[0] }}
                  </p>
                </validation-provider>
              </div>
              <div class="col-6">
                <label
                  class="col-form-label">現在の目標進捗</label>
                <input
                  :value="achievementRate"
                  :placeholder="achievementRate"
                  type="text"
                  class="form-control text-secondary"
                  disabled>
              </div>
            </div>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label mb-2">マークする</label>
            <div class="form-check p-0">
              <input
                id="marked"
                v-model="activity.star"
                class="form-check-input"
                type="checkbox"
                value="">
              <label
                class="form-check-label"
                for="marked" />
            </div>
          </div>
          <div
            ref="activityDetail"
            class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">活動記録</label>
            <textarea
              ref="textarea"
              v-model="activity.detail"
              type="text"
              class="form-control"
              placeholder="活動記録を入力してください"
              :rows="rows"
              @focus="onFocusDetail" />
          </div>
          <div
            v-if="attachmentOption"
            class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">ファイルを添付</label>
            <!-- rules(file_size)によるバリデーションではなくonClickSave内にてバリデーションする -->
            <validation-provider
              ref="activity_file"
              v-slot="v">
              <file-uploader
                v-model="activity.file" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>

          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="onClickSave">
                保存
              </button>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-6">
              <button
                type="button"
                class="btn d-block general-form__btn-delete mx-auto text-right"
                @click="onClickDelete">
                <span class="material-icons general-form__btn-delete__icon">
                  delete
                </span>
                削除する
              </button>
            </div>
            <div class="col-6">
              <button
                v-if="isDraft"
                type="button"
                class="btn btn-block btn-secondary"
                @click="onClickDraft">
                下書き保存
              </button>
            </div>
          </div>
          <div class="general-form__item d-flex form-info justify-content-end mt-5">
            <div class="form-info__detail text-right">
              <div class="form-info__name">
                <p><b class="mr-2">作成者</b>{{ goal.createdBy.name }}</p>
              </div>
              <div class="form-info__date">
                <p>最終更新日時: {{ activity.updatedAt | prettyDateTime }}</p>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </BasePageContainer>
</template>

<script>
import validate from '@/components/mixin/validate'
import FileUploader from '@/components/parts/FileUploader'

import { isIOS } from '@/helper/device'

export default {
  components: {
    FileUploader
  },
  mixins: [
    validate
  ],
  data() {
    return {
      activity: null,
      activities: [],
      goal: null,
      totalActivityCount: 0,
      workAtDate: '',
      workAtTime: '',
      oldFile: null,
      attachmentOption: false,
      rows: 8,
      initialContainerHeight: null,
      isIOS,
      scrollDelay: 100,
      containerPaddingBottom: '48px',
      isDraft: false
      
    }
  },
  computed: {
    memberId() {
      return this.$route.params.id
    },
    goalId() {
      return this.$route.params.goalId
    },
    activityId() {
      return this.$route.params.activityId
    },
    achievementRate() {
      if (!this.goal) return ''
      return `${this.totalActivityCount} / ${this.goal.goalNumber}`
    },
    workAt() {
      return `${this.workAtDate}T${this.workAtTime}+09:00`
    },
    hasFile() {
      if (!this.activity) return false
      return !!this.activity.file
    },
    fileIsUpdated() {
      if (!this.activity) return false
      return this.oldFile !== this.activity.file
    },
    normalBody() {
      return {
        name: this.activity.name,
        work_at: this.workAt,
        detail: this.activity.detail,
        result_count: this.activity.resultCount,
        star: this.activity.star,
        goal: this.goalId,
        file: this.activity.file
      }
    },
    formData() {
      const form = new FormData()
      form.append('name', this.activity.name)
      form.append('work_at', this.workAt)
      form.append('detail', this.activity.detail)
      form.append('result_count', this.activity.resultCount)
      form.append('star', this.activity.star)
      form.append('goal', this.goalId)
      form.append('file', this.activity.file)
      return form
    },
    formDataWithoutFile() {
      const form = new FormData()
      form.append('name', this.activity.name)
      form.append('work_at', this.workAt)
      form.append('detail', this.activity.detail)
      form.append('result_count', this.activity.resultCount)
      form.append('star', this.activity.star)
      form.append('goal', this.goalId)
      return form
    },
    draftData() {
      const form = new FormData()
      form.append('name', this.activity.name)
      form.append('work_at', this.workAt)
      form.append('detail', this.activity.detail)
      form.append('result_count', this.activity.resultCount)
      form.append('star', this.activity.star)
      form.append('file', this.activity.file)
      return form
    },
  },
  created() {
    this.init()
  },
  methods: {
    async onFocusDetail() {
      // 画面上にくるようにするためには十分にスクロールできるだけの余裕が必要なので、
      // focusあたったらpadding-bottomを大きくする
      this.containerPaddingBottom = `${this.initialContainerHeight * 0.5}px`
    
      // containerの幅の更新が反映されてからスクロール
      await this.$nextTick(() => {
        this.scrollToDetail()
      })
      // スクロール後は元に戻す
      this.containerPaddingBottom = '48px'
    },
    scrollToDetail() {
      const target = this.$refs.activityDetail
      const clientRect = target.getBoundingClientRect() 
      // スクロールでヘッダーに埋もれないために、ヘッダーの高さ分差し引き
      // ただしiOSでは基本、focusあたるとヘッダーがページ外に追いやられるので0に設定
      const factor = isIOS ? 0 : -60
      const y = clientRect.top + window.pageYOffset + factor
      // ios safariではfocus時に自動でスクロールがかかる模様。
      // そのためsetTimeoutでスクロールのバッティングを防ぐ
      // ref: https://stackoverflow.com/questions/52652469/prevent-safari-from-automatically-scrolling-to-focused-element-scrollback-techn
      window.setTimeout(() => {
        window.scrollTo({
          top: y,
          left: 0,
          behavior: 'smooth'
        })
      }, this.scrollDelay)
    },
    init() {
      this.isDraft = this.$route.query.isDraft
      // 原因不明だが、たまにqueryから取得したisDraftがstringの場合があるのでbooleanに変換
      if (typeof this.isDraft === 'string') {
        this.isDraft = this.isDraft === 'true'
      }

      this.$store.commit('startLoading')
      return Promise.all([this.fetchActivitiesOrDrafts(), this.fetchGoal(), this.fetchTenantInfo()])
        .then(() => {
          this.initialContainerHeight = this.$refs.container.clientHeight
        })
        .catch((err) => {
          console.error(err)
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        }).finally(() => {
          this.$store.commit('finishLoading')
        })
    },
    fetchActivities() {
      return this.$axios.get(`/activities/activity_results/?goal=${this.goalId}`, {
        params: {
          limit: 99999
        }
      }).then(async res => {
        this.activities = res.data.results
        this.activity = this.activities.slice().find(a => a.id === this.activityId)
        this.oldFile = this.activity.file
        const workAtArray = this.activity.workAt.split('T')
        this.workAtDate = workAtArray[0]
        this.workAtTime = workAtArray[1].slice(0, 5)
        this.totalActivityCount = this.activities.slice().reduce((accumulator, current)=> {
          return accumulator + current.resultCount
        }, 0)
      }).catch((e) => {
        console.error(e)
        throw e
      })
    },
    fetchActivitiesOrDrafts() {
      if (this.isDraft) {
        this.fetchDrafts()
      } else {
        this.fetchActivities()
      }
    },
    // fetchActivities() {
    //    return this.$axios.get(`/activities/activity_results/?goal=${this.goalId}`).then(res => res.data.results)
    // },
    // fetchDrafts() {
    //   return this.$axios.get(`/goals/${this.goalId}/activity_drafts/`).then(res => res.data.results)
    // },
    fetchDrafts(){
      return this.$axios.get(`/goals/${this.goalId}/activity_drafts/`).then(async res => {
        this.activities = res.data.results
        this.activity = this.activities.slice().find(a => a.id === this.activityId)
        this.oldFile = this.activity.file
        const workAtArray = this.activity.workAt.split('T')
        this.workAtDate = workAtArray[0]
        this.workAtTime = workAtArray[1].slice(0, 5)
        this.totalActivityCount = this.activities.slice().reduce((accumulator, current)=> {
          return accumulator + current.resultCount
        }, 0)
      }).catch((e) => {
        console.error(e)
        throw e
      })
    },
    fetchGoal() {
      return this.$axios.get(`/goals/${this.goalId}/`).then(res => {
        this.goal = res.data

      })
    },
    async fetchTenantInfo() {
      const tenantInfo = await this.$axios.get('/tenants/')
      this.attachmentOption = tenantInfo.data.attachmentOption
      return
    },
    async onClickSave() {
      const isValid = await this.validateAndScroll()
      if (!isValid) return

      if (this.isDraft) {
        await this.createActivityFromDraft()
        return
      }
      // ファイルがnullの場合 (ファイルが削除された場合も含む)
      if (!this.hasFile) {
        await this.updateActivity(this.normalBody)
        return
      }
      // ファイルがもとのデータから変更されていない場合
      if (!this.fileIsUpdated) {
        // ファイルは送信しない
        await this.updateActivity(this.formDataWithoutFile)
        return
      }
      // ファイルが新たに登録された場合
      // バリデーション必要
      const fileIsValid = this.validateFileSize(this.activity.file)
      if (!fileIsValid) {
        this.$refs.activity_file.applyResult({
          errors: ['5MB以上のサイズのファイルはアップロードできません'],
          valid: false,
          failedRules: {}
        })
        return
      }
      await this.updateActivity(this.formData)
    },
    /*
     validation.jsに"file_size"のバリデーションがあるが、今回は使わない。
     理由は、今回ファイルがURLになる場合(ファイルがAPIから取得したデータのままで変更されない場合)があり、
     このケースではファイルをサーバーに送信しないためバリデーションが不要なのに"file_size"バリデーションが走り、
     処理が中断してしまうため。
    */
    validateFileSize(v) {
      const MB = 2 ** 20
      return v.size < 5 * MB
    },
    updateActivity(requestBody) {
      this.$store.commit('startLoading')
      this.$axios.patch(`/activities/activity_results/${this.activityId}/`, requestBody).then(() => {
        this.$router.push(`/members/${this.memberId}?goalId=${this.goalId}`)
        this.$store.commit('notify/set', {message: '活動を保存しました。'})
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    async createActivityFromDraft(){
      // ファイルがnullの場合 (ファイルが削除された場合も含む)
      if (!this.hasFile) {
        await this.saveAndPublishAndDeleteDraft(this.normalBody, this.activityId)
        return
      }
      // ファイルがもとのデータから変更されていない場合
      if (!this.fileIsUpdated) {
        // ファイルは送信しない
        await this.saveAndPublishAndDeleteDraft(this.formDataWithoutFile, this.activityId)
        return
      }
      // ファイルが新たに登録された場合
      // バリデーション必要
      const fileIsValid = this.validateFileSize(this.activity.file)
      if (!fileIsValid) {
        this.$refs.activity_file.applyResult({
          errors: ['5MB以上のサイズのファイルはアップロードできません'],
          valid: false,
          failedRules: {}
        })
        return
      }
      await this.saveAndPublishAndDeleteDraft(this.formData, this.activityId)
    },
    createActivity(requestBody){
      this.$store.commit('startLoading')
      this.$axios.post('/activities/activity_results/', requestBody).then(() => {
        this.$axios.delete(`/goals/${this.goalId}/activity_drafts/${this.activityId}/`)
        this.$router.push(`/members/${this.memberId}?goalId=${this.goalId}`)
        this.$store.commit('notify/set', {message: '活動を保存しました。'})
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    onClickCancel() {
      this.$router.push(`/members/${this.memberId}`)
    },
    onClickDelete() {
      const activityType = this.isDraft ? '下書き' : '活動'
      if (!window.confirm(`${activityType}を削除してもよろしいですか?`)) return
      return this.isDraft ? this.deleteDraft() : this.deleteActivity()
    },
    deleteActivity(){
      this.$store.commit('startLoading')
      this.$axios.delete(`/activities/activity_results/${this.activityId}/`).then(() => {
        this.$store.commit('notify/set', {message: '活動を削除しました。'})
        this.$router.replace(`/members/${this.memberId}`)
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    deleteDraft(){
      this.$store.commit('startLoading')
      return this.$axios.delete(`/goals/${this.goalId}/activity_drafts/${this.activityId}/`).then(() => {
        this.$store.commit('notify/set', {message: '下書きを削除しました。'})
        this.$router.replace(`/members/${this.memberId}`)
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    async onClickDraft() {
      const isValid = await this.validateAndScroll()
      if (!isValid) return

      // ファイルがnullの場合 (ファイルが削除された場合も含む)
      if (!this.hasFile) {
        await this.updateDraft(this.normalBody)
        return
      }
      // ファイルがもとのデータから変更されていない場合
      if (!this.fileIsUpdated) {
        // ファイルは送信しない
        await this.updateDraft(this.formDataWithoutFile)
        return
      }
      // ファイルが新たに登録された場合
      // バリデーション必要
      const fileIsValid = this.validateFileSize(this.activity.file)
      if (!fileIsValid) {
        this.$refs.activity_file.applyResult({
          errors: ['5MB以上のサイズのファイルはアップロードできません'],
          valid: false,
          failedRules: {}
        })
        return
      }
      await this.updateDraft(this.formData)
    },
    updateDraft(requestBody) {
      this.$store.commit('startLoading')
      this.$axios.patch(`/goals/${this.goalId}/activity_drafts/${this.activityId}/`, requestBody).then((res) => {
        this.$router.push(`/members/${this.memberId}?goalId=${res.data.goal}`)
        this.$store.commit('notify/set', {message: '下書きを保存しました。'})
      }).catch(() => {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    async saveAndPublishAndDeleteDraft(requestBody, activityId) {
      this.$store.commit('startLoading')
      // Draftを公開する場合、Draftを最新の状態で保存、Draftから活動記録を作成、Draftのデータを削除の３処理のエンドポイントを使う
      try {
        await this.$axios.patch(`/goals/${this.goalId}/activity_drafts/${this.activityId}/`, requestBody)
        await this.$axios.post('/activities/activity_results/publish_draft/', { activity_draft: activityId })
        await this.$axios.delete(`/goals/${this.goalId}/activity_drafts/${activityId}/`)
      } catch (e) {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        return
      } finally {
        this.$store.commit('finishLoading')
      }
      this.$router.push(`/members/${this.memberId}?goalId=${this.goalId}`)
    },
    dateErrorMessage(v) {
      if (!v) return ''
      return v[0]
    },
  }
}
</script>

<style lang="scss" scoped>
.edit-head{
  background-color: $l-blue;
    @media screen and (min-width:992px) {
    width: calc(100% - 422px);
    right: 0;
    left: auto;
  }
  &__icon{
    height: 22px;
    width: auto;
    @media screen and (max-width:320px) {
      height: 18px;
    }
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
  &__activity{
    position: relative;
    font-size: $fs-nm;
    @media screen and (max-width:320px) {
      font-size: $fs-m;
    }
  }
}

.form-check {
  position:relative;
}

input[type="checkbox"] {
  display:none;
}

.form-check-label {
  display: block;
  // padding: 10px 10px 10px 40px;
  cursor:pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: $white;
}

.form-check-label:after {
  content: "";
  width: 20px;
  height: 20px;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  margin: -10px 8px;
  background-color: $grey16;
  border-radius: 50%;
}

input[type="checkbox"]:checked + .form-check-label:after {
  background-color: $pink;
}
.form-info{
  color: $grey09;
  &__delete{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
  }
  &__icon{
    display: inline-block;
    vertical-align: top;
  }
  &__date{
    font-size: $fs-m;
  }
}

.general-form__btn-delete {
  color: $grey09;
  position: relative;
  padding: 0;
  line-height: 48px;
  &__icon{
    position:absolute;
    top:11px;
    left:-24px;
  }
}
</style>